import { render, staticRenderFns } from "./CustomerViewContacts.vue?vue&type=template&id=f341cc10"
import script from "./CustomerViewContacts.vue?vue&type=script&lang=js"
export * from "./CustomerViewContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports